module.exports = __webpack_public_path__ + "img/collection3.b8258c68.png";